<template>
	<div>
		<CRow class="responsiveness-navbar mx-0">
			<CCol class="py-4 mb-0" style="text-align: center">
				<img :src="logo" width="200px" alt="" class="my-auto" />
			</CCol>
		</CRow>
		<br /><br />
		<CRow class="mx-1">
			<CCol>
				<center>
					<div class="responsiveness-header">Welcome to SpendMD!</div>
					<h4 class="responsiveness-error">
						This web application is not suitable for mobile and tablet screens.
					</h4>
				</center>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import logo from "../../assets/images/logo.svg";

export default {
	data() {
		return {
			logo,
		};
	},
};
</script>

<style scoped>
.responsiveness-main {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.responsiveness-header {
	color: #0c103d;
	font-size: 25px;
	font-weight: bold;
	font-family: "Montserrat";
}
.responsiveness-error {
	text-align: center;
	margin-top: 30px;
	display: flex;
	flex-direction: column;
	height: fit-content;
	/* box-shadow: 0px 0px 1px 1px lightgray; */
}
.responsiveness-navbar {
	height: 70px;
	background-color: #106f44;
	padding: 0px 30px;
	font-weight: bold;
	padding-bottom: 0px !important;
	font-family: "Montserrat";
}

.responsiveness-nav_header {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;

	padding-left: 3%;
	padding-bottom: 10px;
	color: white;
	font-weight: bold;
	font-size: 16px;
	font-family: "Montserrat";
}
</style>
